export default __webpack_public_path__ + "static/media/abby-shovel.585fef0b.jpg";